'use strict';

angular.module('TurneroApp').service('puestosService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Puesto/:id', { id: '@Id_Puesto' }, {
        getInfo: {
            method: 'GET',
            params: {
                id_centro_atencion: 'id_centro_atencion',
                id_Puesto: 'id_Puesto'
            },
            url: portal.getUrlServer() + 'api/Puesto/getInfo/'
        },
        getfiltro: {
            method: 'GET',
            withcredentials: true,
            params: {
                id_Centro_Atencion: '@id_Centro_Atencion',
                nro_Pagina: '@nro_Pagina',
                tam_Pagina: '@tam_Pagina',
                texto: '@texto'
            },
        },
        Get_Puesto_Estado_Supervision: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Puesto/Estado_Supervision/:id_centro_atencion/'
        },
        Put_Puesto_Liberar: {
            method: 'POST',
            url: portal.getUrlServer() + 'api/Puesto/Liberar/'
        },
        Put_Puestos_Liberar: {
            method: 'PUT',
            url: portal.getUrlServer() + 'api/Puesto/Liberar_Puestos/',
            params: {
                id_Centro_Atencion: '@id_Centro_Atencion'
            }
        },
        Get_Puestos_Combo_Atencion: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Puesto/Get_Puestos_Combo_Atencion/'
        },
        Put_Pausar_Puestos: {
            method: 'PUT',
            params: {
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
            },
            url: portal.getUrlServer() + 'api/Puesto/Put_Pausar_Puestos/'
        },
        Put_Despausar_Puestos: {
            method: 'PUT',
            url: portal.getUrlServer() + 'api/Puesto/Put_Despausar_Puestos/'

        },
        save: {
            method: 'POST'
        },
        'delete': {
            method: 'DELETE'
        },
        update: {
            method: 'PUT'
        },
        Guardar_Orden_Puestos: {
            method: 'POST',
            url: portal.getUrlServer() + 'api/Puesto/Guardar_Orden_Puestos/',
            params: {
                nro_Pagina: '@nro_Pagina',
                tam_Pagina: '@tam_Pagina',
            },
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/puestos/puestosService.js